import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './Link.scss';

export const Link = ({ label, highlighted, ...rest }) => (
  <li
    className={cx(css.base, {
      [css.isHighlighted]: highlighted,
    })}
    {...rest}>
    <div className={css.content}>{label}</div>
  </li>
);

Link.propTypes = {
  label: PropTypes.object.isRequired,
  highlighted: PropTypes.bool.isRequired,
};
